
import Vue from 'vue'
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from './router'
import store from './store';
import vuescroll from 'vue-scroll'
import {ColorPicker,Button,Input,Dropdown} from 'element-ui';
import axios from 'axios'
import {api} from '@/api/api.js'
import './iconfont/iconfont.css'
import './iconfont/iconfont.js'
import './font2/iconfont.css'
import './font2/iconfont.js'
import VueLazyLoad from 'vue-lazyload'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './iconfont-mobile/iconfont.css'
import './iconfont-mobile/iconfont.js'
import { message } from 'ant-design-vue'
Vue.use(VueLazyLoad,{
    error:'./assets/error.jpg',
    loading:'./assets/load.jpg'
})

Vue.use(vuescroll, { debounce: 500 })
Vue.use(router)
Vue.use(Antd);
Vue.use(ColorPicker,Button,Input,Dropdown);
Vue.component('quillEditor', quillEditor)
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$api = api


new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')

